import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//subscription api
import apiService from './api.service';
import { UrlList, replaceParamVal } from './accountSetting.api';
export var getSubscriptionsApi = function getSubscriptionsApi(_ref) {
  var solutionId = _ref.solutionId,
      pageIndex = _ref.pageIndex,
      pageSize = _ref.pageSize,
      orderBy = _ref.orderBy,
      orderDirection = _ref.orderDirection;
  return apiService.get(replaceParamVal(UrlList.subscriptionUrls.getSubscriptions, {
    solutionId: solutionId,
    pageIndex: pageIndex,
    pageSize: pageSize,
    orderBy: orderBy,
    orderDirection: orderDirection
  }));
};
export var getAllAssetsApi = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var param, _yield$apiService$pos, data, asset;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            param = {
              page: 0,
              pageSize: 10000
            };
            _context.next = 3;
            return apiService.post(UrlList.subscriptionUrls.getAllAssets, param);

          case 3:
            _yield$apiService$pos = _context.sent;
            data = _yield$apiService$pos.data;
            // When the SubscriptionPackage is Lite, it means that the asset has no subscription.
            asset = data.filter(function (i) {
              return i.SubscriptionPackage === 'Lite';
            }).map(function (n) {
              return n.HMISystem && n.HMISystem.ShortName ? _objectSpread({
                Name: n.HMISystem.ShortName
              }, n) : _objectSpread({
                Name: n.ObjectID
              }, n);
            });
            asset.unshift({
              Name: '',
              ObjectID: ''
            });
            return _context.abrupt("return", asset);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAllAssetsApi() {
    return _ref2.apply(this, arguments);
  };
}();
export var assignSubscription = function assignSubscription(params) {
  return apiService.put(UrlList.subscriptionUrls.assignSubscription, params);
};
export var validateVoucherCode = function validateVoucherCode(voucherCode) {
  return apiService.get(replaceParamVal(UrlList.subscriptionUrls.validateVoucherCode, {
    voucherCode: voucherCode
  }));
};
export var consumeVoucherCode = function consumeVoucherCode(voucherCode) {
  return apiService.put(replaceParamVal(UrlList.subscriptionUrls.useVoucherCode, {
    voucherCode: voucherCode
  }));
};